
import Vue from 'vue'
import DashboardAlertCtl from './DashboardAlertCtl.vue';
import DashboardQueueList from './DashboardQueueList.vue'
import DashboardTasking from './DashboardTasking.vue'
import DashboardRecentBookings from './DashboardRecentBookings.vue'
import DashboardPatientHotlist from './DashboardPatientHotlist.vue'
import DashboardResources from './DashboardResource.vue'
import DashboardMessaging from './DashboardMessaging.vue';
import { DashboardAlert } from 'types/Sapphire_dto';


export default Vue.extend({
    name: "dashboard-main-vue-component",
    components: {
        DashboardAlertCtl,
        DashboardQueueList,
        DashboardTasking,
        DashboardMessaging,
        DashboardRecentBookings,
        DashboardPatientHotlist,
        DashboardResources
    },    
    data: function() {
    return {
        usr: '',
        fac: '',
        pageSize: 20,
        // queueListData: new sapphire.dashboardQueueListVueComponent.dataObj(),
        // queueListVC: {},
        // reportControlData: new sapphire.dashboardReportControlVueComponent.dataObj(),
        reportControlVC: {},
        // tasks: [],
        // totalTaskCount: 0,
        bookings: [],
        // taskCategories: [],
        // taskRoles: [],
        // taskStatus: [],
        // taskReasons: [],
        // taskTimes: [],
        dashAlerts: Object() as DashboardAlert,
        userMessages: {},
        hotlistTypes: [],
        hotlistPatients: [],
        // dataLoading: true,
        loadMessagingControl: false,
        // isLoaded: true,
        }
    },
    created: function () {

        // Register Sapphire Dashboard View Components
        // this.queueListVC = sapphire.dashboardQueueListVueComponent.register("one-third");
        // this.reportControlVC = sapphire.dashboardReportControlVueComponent.register("one-third");
        // sapphire.messagingControlVueComponent.register();

        // Setup Dashboard Switcher
        //setupDashboardSwitcher();

    },
    // mounted: function () {
    //     // Load Data
    //     this.loadData();
    // },
    methods: {
        async loadData(fac, usr) {

            this.fac = fac;
            this.usr = usr;
        }
    }
});
